<template>
    <div>
        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-calendar-alt"></i>
            </template>
            <template slot="title">Date</template>
            <template slot="sub-title">{{formatDate(expense.date, 'D MMM YYYY')}}</template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-money-bill"></i>
            </template>
            <template slot="title">Total Amount</template>
            <template slot="sub-title">
                {{expense.amount.join('.')}}
                {{expense.currency}}
            </template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-utensils"></i>
            </template>
            <template slot="title">Meal Deduction Total Amount</template>
            <template slot="sub-title">
                {{expense.deduction.join('.')}}
                {{expense.currency}}
            </template>
        </list-item>
    </div>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
    mixins: [InteractsWithDates],
    props: ['expense'],
}
</script>
